import Spacer from "components/global/Spacer";
import styled from "styled-components";
import RocketLaunchIcon from "icons/RocketLaunchIcon";
import Button from "components/global/Button";
import ArrowRight from "assets/icons/arrowIcon-right.svg";
import quickPost from "assets/images/mini-apps/quick-post.png";
import postCaptionImg from "assets/images/mini-apps/post-captions.png";
import imgCaption from "assets/images/mini-apps/Image-caption.png";
import ImageCaptionIcon from "icons/ImageCaptionIcon";
import postIdeasImg from "assets/images/mini-apps/post-ideas.png";
import LightBulbIcon from "icons/LightBulbIcon";
import PencilIcon from "icons/PencilIcon";
import { useHistory } from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  width: 600px;
  height: calc(100vh - 72px);
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex-shrink: 0;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
`;

const ToolCard = styled.div`
  display: flex;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid #e2e2ea;
  background: #fff;

  .leftWrapper {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
  }

  .rightWrapper {
    display: flex;
    overflow: hidden;
    align-items: ${({ id }) =>
      +id === 2 || +id === 3 ? "center" : "flex-end"};
    justify-content: flex-end;
    height: 100%;
    width: 40%;
    max-width: 40%;
    height: 180px;
    max-height: 180px;

    img {
      width: 100%;
      height: 80%;
      object-fit: ${({ id }) => (+id > 0 ? "cotain" : "cover")};
      margin: 0;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .rightWrapper {
      display: none;
    }
  }
`;

const ToolsList = () => {
  const history = useHistory();

  const tools = [
    {
      title: "Quick post",
      description:
        "Instantly create engaging content tailored to your brand's voice.",
      image: quickPost,
      icon: <RocketLaunchIcon color="#149DFF" />,
    },
    {
      title: "Image to Caption",
      description:
        "Instantly create engaging content tailored to your brand's voice.",
      image: imgCaption,
      icon: <ImageCaptionIcon />,
    },
    {
      title: "Post Ideas",
      description:
        "Create post ideas and transform them into captivating captions for your brand.",
      image: postIdeasImg,
      icon: <LightBulbIcon />,
    },
    {
      title: "Post Caption",
      description:
        "Share your ideas, and we'll generate the perfect captions for your brand.",
      image: postCaptionImg,
      icon: <PencilIcon color="#149DFF" size={20} />,
    },
  ];

  const handleClick = (title) => {
    const formattedTitle = title.toLowerCase().replace(/\s+/g, "-");
    history.push(`/mini-apps/tool?tool=${formattedTitle}`);
  };

  return (
    <Wrapper>
      <div className="flexRow alignCenter justifyStart">
        <h5>Try out these tools</h5>
      </div>

      {tools.map((tool, index) => (
        <ToolCard
          key={index}
          id={index}
          onClick={(e) => {
            e.stopPropagation();
            handleClick(tool.title);
          }}
        >
          <div className="flexCol leftWrapper">
            <div className="flexCol">
              <div className="flexRow alignCenter">
                {tool.icon}
                <Spacer x={1} />
                <p className="semiBold">{tool.title}</p>
              </div>
              <Spacer y={0.5} />
              <p className="l3 colorBodyText">{tool.description}</p>
            </div>
            <Button
              text="Try now"
              endIcon={ArrowRight}
              height="36px"
              fontSize="14px"
              className="borderedGrey"
              onClick={(e) => {
                e.stopPropagation();
                handleClick(tool.title);
              }}
            />
          </div>
          <div className="rightWrapper">
            <img src={tool.image} alt={tool.title} width="100%" height="100%" />
          </div>
        </ToolCard>
      ))}
    </Wrapper>
  );
};

export default ToolsList;
